import cx from 'clsx';
import React from 'react';

type Props = {
  className?: string;
  indeterminate?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const ControlledCheckbox: React.FC<Props> = ({ className, indeterminate = false, ...otherProps }) => {
  const ref = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (!ref.current) return;
    ref.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <div className="flex items-center">
      <label className="relative flex cursor-pointer items-center">
        <input
          ref={ref}
          type="checkbox"
          className={cx(
            'peer h-5 w-5 cursor-pointer appearance-none border border-grey-border bg-white',
            'checked:border-blue-600 checked:bg-blue-600',
            'indeterminate:border-blue-600 indeterminate:bg-blue-600',
            className,
          )}
          {...otherProps}
        />
        <span className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform text-white opacity-0 peer-checked:opacity-100">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg>
        </span>
        {indeterminate && (
          <span className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform text-white opacity-0 peer-indeterminate:opacity-100">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
            </svg>
          </span>
        )}
      </label>
    </div>
  );
};
